const IncomingInvoice = {
  State_0: "IncomingInvoice.State_0",
  State_1: "IncomingInvoice.State_1",
  State_2: "IncomingInvoice.State_2",
  State_3: "IncomingInvoice.State_3",
  State_4: "IncomingInvoice.State_4",
  State_5: "IncomingInvoice.State_5",
  State_6: "IncomingInvoice.State_6",
  State_7: "IncomingInvoice.State_7",
  State_8: "IncomingInvoice.State_8",
  State_9: "IncomingInvoice.State_9",
  State_10: "IncomingInvoice.State_10",
  StateFlowState_0: "IncomingInvoice.StateFlowState_0",
  StateFlowState_1: "IncomingInvoice.StateFlowState_1",
  StateFlowState_3: "IncomingInvoice.StateFlowState_3",
  StateFlowState_5: "IncomingInvoice.StateFlowState_5",
  StateFlowState_7: "IncomingInvoice.StateFlowState_7",
  StateFlowState_9: "IncomingInvoice.StateFlowState_9",
  StateFlowState_14: "IncomingInvoice.StateFlowState_14",
  ToCertify: "IncomingInvoice.ToCertify",
  ToSign: "IncomingInvoice.ToSign",
  ForwardMessage: "IncomingInvoice.ForwardMessage",
  InvoiceCategoryText: "IncomingInvoice.InvoiceCategoryText",
  SelectCategory: "IncomingInvoice.SelectCategory",
  SelectCategorySubText: "IncomingInvoice.SelectCategorySubText",
  DialogSubTitle: "IncomingInvoice.DialogSubTitle",
  SendBackDefaultMessage: "IncomingInvoice.SendBackDefaultMessage",
  SendBackDefaultSubject: "IncomingInvoice.SendBackDefaultSubject",
  IncomingInvoiceFrom: "IncomingInvoice.IncomingInvoiceFrom",
  IncomingInvoices: "IncomingInvoice.IncomingInvoices",
  IncomingInvoice: "IncomingInvoice.IncomingInvoice",
  AccountRequiredInfoMessage: "IncomingInvoice.AccountRequiredInfoMessage",
  AmountExVATHelpText: "IncomingInvoice.AmountExVATHelpText",
  VATHelpText: "IncomingInvoice.VATHelpText",
  AmountHelpText: "IncomingInvoice.AmountHelpText",
  CurrencyHelpText: "IncomingInvoice.CurrencyHelpText",
  InvoiceDateHelpText: "IncomingInvoice.InvoiceDateHelpText",
  DueDateHelpText: "IncomingInvoice.DueDateHelpText",
  OCRText: "IncomingInvoice.OCRText",
  PaymentDateHelpText: "IncomingInvoice.PaymentDateHelpText",
  IsCreditInvoiceHelpText: "IncomingInvoice.IsCreditInvoiceHelpText",
  AccuralHelpText: "IncomingInvoice.AccuralHelpText",
  EditPeriodisation: "IncomingInvoice.EditPeriodisation",
  AddPeriodisation: "IncomingInvoice.AddPeriodisation",
  PossibleDuplcateWarningMessage: "IncomingInvoice.PossibleDuplcateWarningMessage",
  ForwardSuccessMessage: "IncomingInvoice.ForwardSuccessMessage",
  SendBackSuccessMessage: "IncomingInvoice.SendBackSuccessMessage",
  PaymentUpdatedSuccessMessage: "IncomingInvoice.PaymentUpdatedSuccessMessage",
  MovedToAccountingSuccessMessage: "IncomingInvoice.MovedToAccountingSuccessMessage",
  SnoozeSuccessMessage: "IncomingInvoice.SnoozeSuccessMessage",
  CancelSuccessMessage: "IncomingInvoice.CancelSuccessMessage",
  ApproveSuccessMessage: "IncomingInvoice.ApproveSuccessMessage",
  UpdateSuccessMessage: "IncomingInvoice.UpdateSuccessMessage",
  PaymentTermsHelpText: "IncomingInvoice.PaymentTermsHelpText",
  PaymentTermsHelpTextLink: "IncomingInvoice.PaymentTermsHelpTextLink",
  SoonDueMessage: "IncomingInvoice.SoonDueMessage",
  OverDueMessage: "IncomingInvoice.OverDueMessage",
  SoonDueInDays: "IncomingInvoice.SoonDueInDays",
  OverDueOn: "IncomingInvoice.OverDueOn",
  SendBackEmailHelpText: "IncomingInvoice.SendBackEmailHelpText",
  SendBackSubjectHelpText: "IncomingInvoice.SendBackSubjectHelpText",
  SendBackMessageHelpText: "IncomingInvoice.SendBackMessageHelpText",
  UpdatePaymentAlreadyPaidHelpText: "IncomingInvoice.UpdatePaymentAlreadyPaidHelpText",
  UpdatePaymentPaymentDateHelpText: "IncomingInvoice.UpdatePaymentPaymentDateHelpText",
  SupplierInvoiceDateHelpText: "IncomingInvoice.SupplierInvoiceDateHelpText",
  SupplierNameHelpText: "IncomingInvoice.SupplierNameHelpText",
  ReceiverHelpText: "IncomingInvoice.ReceiverHelpText",
  InvoiceNoHelpText: "IncomingInvoice.InvoiceNoHelpText",
  SupplierDueDateHelpText: "IncomingInvoice.SupplierDueDateHelpText",
  SupplierAmountInclVATHelpText: "IncomingInvoice.SupplierAmountInclVATHelpText",
  LeftToPayHelpText: "IncomingInvoice.LeftToPayHelpText",
  StatusHelpText: "IncomingInvoice.StatusHelpText",
  PaidHelpText: "IncomingInvoice.PaidHelpText",
  AccountsPayable: "IncomingInvoice.AccountsPayable",
  DateOfAccountsPayable: "IncomingInvoice.DateOfAccountsPayable",
  DateOfAccountsPayableHelpText: "IncomingInvoice.DateOfAccountsPayableHelpText",
  ViewState_0: "IncomingInvoice.ViewState_0",
  ViewState_1: "IncomingInvoice.ViewState_1",
  ViewState_2: "IncomingInvoice.ViewState_2",
  ViewState_3: "IncomingInvoice.ViewState_3",
  ViewState_4: "IncomingInvoice.ViewState_4",
  ViewState_5: "IncomingInvoice.ViewState_5",
  PaymentStatus_0: "IncomingInvoice.PaymentStatus_0",
  PaymentStatus_1: "IncomingInvoice.PaymentStatus_1",
  PaymentStatus_2: "IncomingInvoice.PaymentStatus_2",
  PaymentStatus_3: "IncomingInvoice.PaymentStatus_3",
  PaymentStatus_4: "IncomingInvoice.PaymentStatus_4",
  PaymentStatus_5: "IncomingInvoice.PaymentStatus_5",
  StatusGraphTitle: "IncomingInvoice.StatusGraphTitle",
  DueInGraphTitle: "IncomingInvoice.DueInGraphTitle",
  PaidInvoices: "IncomingInvoice.PaidInvoices",
  UnpaidInvoices: "IncomingInvoice.UnpaidInvoices",
  UnderProcessing: "IncomingInvoice.UnderProcessing",
  PG_BG: "IncomingInvoice.PG_BG",
  PaymentNumberType_0: "IncomingInvoice.PaymentNumberType_0",
  PaymentNumberType_1: "IncomingInvoice.PaymentNumberType_1",
  PaymentNumberType_2: "IncomingInvoice.PaymentNumberType_2",
  Supplier: "IncomingInvoice.Supplier",
  SupplierOrgNr: "IncomingInvoice.SupplierOrgNr",
  Bankgiro: "IncomingInvoice.Bankgiro",
  Plusgiro: "IncomingInvoice.Plusgiro",
  IBAN: "IncomingInvoice.IBAN",
  DueDateDiff: "IncomingInvoice.DueDateDiff",
  AgentInvoices: "IncomingInvoice.AgentInvoices",
  UnapprovedOrCloseToDueDateWarningMessage: "IncomingInvoice.UnapprovedOrCloseToDueDateWarningMessage",
  CreateFromUIWarning: "IncomingInvoice.CreateFromUIWarning",
  CreateFromUIOnboardedInfo: "IncomingInvoice.CreateFromUIOnboardedInfo",
  CreateFromUIOnboardedTipPart1: "IncomingInvoice.CreateFromUIOnboardedTipPart1",
  CreateFromUIOnboardedTipPart2: "IncomingInvoice.CreateFromUIOnboardedTipPart2",
  CompanyInvoiceMailLabel: "IncomingInvoice.CompanyInvoiceMailLabel",
  CompanyInvoiceMailTooltip: "IncomingInvoice.CompanyInvoiceMailTooltip",
  Approval: "IncomingInvoice.Approval",
  FinalApproval: "IncomingInvoice.FinalApproval",
  MissingApproval: "IncomingInvoice.MissingApproval",
  BookedInMonth: "IncomingInvoice.BookedInMonth",
  BookedInSeveralMonths: "IncomingInvoice.BookedInSeveralMonths",
  MissingApprovalHeader: "IncomingInvoice.MissingApprovalHeader",
  MissingApprovalDescripton: "IncomingInvoice.MissingApprovalDescripton",
  AgingOverPaidHeader: "IncomingInvoice.AgingOverPaidHeader",
  AgingOverPaidDescripton: "IncomingInvoice.AgingOverPaidDescripton",
  AgingLeftToPayHeader: "IncomingInvoice.AgingLeftToPayHeader",
  AgingLeftToPayDescripton: "IncomingInvoice.AgingLeftToPayDescripton",
  AgingOverPaidTodoAction_0: "IncomingInvoice.AgingOverPaidTodoAction_0",
  AgingOverPaidTodoAction_1: "IncomingInvoice.AgingOverPaidTodoAction_1",
  AgingUnderPaidTodoAction_0: "IncomingInvoice.AgingUnderPaidTodoAction_0",
  AgingUnderPaidTodoAction_1: "IncomingInvoice.AgingUnderPaidTodoAction_1",
  AgingUnderPaidTodoAction_2: "IncomingInvoice.AgingUnderPaidTodoAction_2",
  AgingUnderPaidTodoAction_3: "IncomingInvoice.AgingUnderPaidTodoAction_3",
  AgingPaymentDateLabel: "IncomingInvoice.AgingPaymentDateLabel",
  AgingPaymentDateHelpText: "IncomingInvoice.AgingPaymentDateHelpText",
  AgingPlannedDateLabel: "IncomingInvoice.AgingPlannedDateLabel",
  AgingOtherInfoLabel: "IncomingInvoice.AgingOtherInfoLabel",
  AgingOtherInfoHelpText: "IncomingInvoice.AgingOtherInfoHelpText",
  AlreadyPaid: "IncomingInvoice.AlreadyPaid",
  AlreadyPaidDescription: "IncomingInvoice.AlreadyPaidDescription",
  OCR: "IncomingInvoice.OCR",
  RefersTo: "IncomingInvoice.RefersTo",
  UnhandledInfoBannerTitle: "IncomingInvoice.UnhandledInfoBannerTitle",
  UnhandledInfoBannerText: "IncomingInvoice.UnhandledInfoBannerText",
  InternationalPaymentViewHeader: "IncomingInvoice.InternationalPaymentViewHeader",
  InternationalPaymentViewSubHeader: "IncomingInvoice.InternationalPaymentViewSubHeader",
  InternationalPaymentViewHelpText: "IncomingInvoice.InternationalPaymentViewHelpText",
  misingBicHeadline: "IncomingInvoice.misingBicHeadline",
  bicFieldLabel: "IncomingInvoice.bicFieldLabel",
  BIC: "IncomingInvoice.BIC",
  InternationalPaymentAndAddressToggleLabel: "IncomingInvoice.InternationalPaymentAndAddressToggleLabel",
  InternationalPaymentAndAddressToolTipText: "IncomingInvoice.InternationalPaymentAndAddressToolTipText",
  AddSupplierPostalAddress: "IncomingInvoice.AddSupplierPostalAddress",
  SupplierAddress: "IncomingInvoice.SupplierAddress",
  SupplierPostalAddressSubText: "IncomingInvoice.SupplierPostalAddressSubText",
  CreditPaymentHandlingTitle: "IncomingInvoice.CreditPaymentHandlingTitle",
  CreditPaymentHandlingDescription: "IncomingInvoice.CreditPaymentHandlingDescription",
  CreditPaymentHandlingInfoMessage: "IncomingInvoice.CreditPaymentHandlingInfoMessage",
  DescribeCreditPaymentHandling: "IncomingInvoice.DescribeCreditPaymentHandling",
  CreditPayment_Refund: "IncomingInvoice.CreditPayment_Refund",
  CreditPayment_UseAgainstFutureInvoices: "IncomingInvoice.CreditPayment_UseAgainstFutureInvoices",
  CreditPayment_Other: "IncomingInvoice.CreditPayment_Other",
  BicOrSwift: "IncomingInvoice.BicOrSwift",
  LearnMoreLink: "IncomingInvoice.LearnMoreLink",
  NoBankIntegrationToolTip: "IncomingInvoice.NoBankIntegrationToolTip",
  NoBankIntegrationInfoMessage: "IncomingInvoice.NoBankIntegrationInfoMessage",
  SplitPeriodisationRemovalTitle: "IncomingInvoice.SplitPeriodisationRemovalTitle",
  SplitPeriodisationRemovalMessage: "IncomingInvoice.SplitPeriodisationRemovalMessage",
  SplitPeriodisationRemovalConfirm: "IncomingInvoice.SplitPeriodisationRemovalConfirm",
  }
export default IncomingInvoice;